module.exports = __webpack_public_path__ + "img/no-favorites.c6846218.svg";